export const MAX_PRODUCTIONS = 3
export const MLB_OPENING_DAY_STRING = ' (Opening Day)'
